import serviceBase from '../../../../Services/serviceBase'

class GalleryActions {
  fetchData = async (legacyId) => {
    let url = `${window._env_.COMMUNITY_API_URL}/gallery/pictures-by-departmentId/${legacyId}`
    return serviceBase.get(url).then(
      (response) => {
        if (response.status === 200) return response.data
        else return undefined
      },
      (err) => {}
    )
  }

  fetchPreviewData = async (legacyId) => {
    let url = `${window._env_.COMMUNITY_API_URL}/gallery-section-preview/${legacyId}`
    return serviceBase.get(url).then(
      (response) => {
        if (response.status === 200) return response.data
        else return undefined
      },
      (err) => {}
    )
  }

  getGalleryEmitStart = async (fireDepartment) => {
    let url = `${window._env_.COMMUNITY_API_URL}/gallery`
    serviceBase.get(`${url}/emit-start/${fireDepartment.fireDepartmentId}`)
  }

  postPublishGallery = async (fireDepartmentIdentifier) => {
    let url = `${window._env_.COMMUNITY_API_URL}/gallery-section-preview/publish/${fireDepartmentIdentifier}`
    return serviceBase.post(url).then(
      (response) => {
        return response.data
      },
      (err) => {}
    )
  }
}

export default new GalleryActions()
